import type { Stage } from '../../types';

export const birth: Stage = {
  id: 'birth',
  key: '4',
  title: '出産前後',
  subtitle: '未知の旅を自分らしく',
  weeks: '出産前後',
  description: '出産は予測不可能です。大切な手続きを忘れず、パートナーと呼吸を合わせましょう。',
  mindCards: [
    { id: 'm1', title: '自分を信じる', body: '出産は未知の旅。自分の体と医療スタッフを信じて身を任せましょう。', type: 'mind' },
    { id: 'm2', title: '産後は急がない', body: '回復は焦らず、小さな休息を重ねていきましょう。', type: 'body' },
    { id: 'm3', title: 'パートナーと呼吸を合わせる', body: '一緒に新しい家族を迎える。声かけだけでも大きな支えになります。', type: 'mind' },
    { id: 'm4', title: '退院後の生活を想像する', body: '自宅の環境とサポートを頼む体制を整えましょう。', type: 'life' },
    { id: 'm5', title: '赤ちゃんとのスキンシップ', body: '沐浴やおむつ替えを通じて、少しずつ親子の信頼を育みます。', type: 'partner' },
    { id: 'm6', title: '手続きは段取りで', body: '出生届や各種申請を、産院や自治体の案内に沿って進めましょう。', type: 'life' },
    { id: 'm7', title: '母乳・ミルクは焦らない', body: '母乳がすぐ出なくても、ミルクで補えば大丈夫。自分を責めないで。', type: 'mind' },
  ],
  checklist: [
    { id: 'c1', text: '入院手続きを済ませる', category: 'hospital', note: '保険証・母子手帳・同意書など' },
    { id: 'c2', text: '出産計画書を持参する', category: 'hospital', note: '陣痛中の対応や痛みの緩和希望' },
    { id: 'c3', text: 'パートナーの立ち会い同意書を確認する', category: 'hospital', note: '産院のルールに従う' },
    { id: 'c4', text: '退院手続きと必要書類を整理する', category: 'admin', note: '出生届・診断書・受診券など' },
    { id: 'c5', text: '出生届の準備と提出期限を確認する', category: 'admin', note: '出産後14日以内' },
    { id: 'c6', text: '母子手帳の交付を確認する', category: 'admin', note: '産院または自治体で' },
    { id: 'c7', text: '出産育児一時金の申請手続きを行う', category: 'admin', note: '産院経由または健康保険組合' },
    { id: 'c8', text: '乳児医療証の手続きを確認する', category: 'admin', note: '自治体の児童課など' },
    { id: 'c9', text: '自宅の環境（ベビー用品・温度）を確認する', category: 'life', note: '室温22〜26度・湿度50〜60%が目安' },
    { id: 'c10', text: '授乳の準備・方法を確認する', category: 'body', note: '母乳・ミルクのどちらでもOK' },
    { id: 'c11', text: '新生児の沐浴方法を確認する', category: 'life', note: '産院の指導を受けながら' },
    { id: 'c12', text: '夜間のサポート体制を確認する', category: 'partner', note: '授乳・おむつ替えの分担' },
    { id: 'c13', text: '退院後の買い物をリスト化する', category: 'shopping', note: '産褥パッド・おむつ・ミルクなど' },
    { id: 'c14', text: 'ママの回復を見守る時間を確保する', category: 'mind', note: '痛みや出血の変化に注意' },
    { id: 'c15', text: '新生児の排泄・睡眠リズムを観察する', category: 'life', note: '母乳・ミルクの回数も記録' },
    { id: 'c16', text: '産後の食事を整える', category: 'body', note: '栄養バランスと水分補給' },
    { id: 'c17', text: '赤ちゃんとの健診予約を確認する', category: 'hospital', note: '1か月健診・予防接種' },
    { id: 'c18', text: 'パートナーに感謝を伝える', category: 'mind', note: '小さな支えも言葉にすると続く' },
    { id: 'c19', text: '出生届を14日以内に提出する', category: 'admin', note: '父または母の本籍地・住所地の市区町村へ' },
    { id: 'c20', text: '児童手当の申請をする', category: 'admin', note: '0歳児は満3歳まで月額15,000円（所得制限あり）。出生した月の月末までに申請を。' },
    { id: 'c21', text: 'こども医療費助成の申請をする', category: 'admin', note: '自治体により対象年齢や助成内容が異なります。健康保険加入後に手続き。' },
    { id: 'c22', text: '新生児聴覚検査・先天性代謝異常検査を受ける', category: 'hospital', note: '聴覚検査は生後すぐ、代謝異常検査は生後4〜6日頃に採血' },
    { id: 'c23', text: '産後ケア事業を利用する（申請済みなら）', category: 'admin', note: '宿泊型・デイ型・訪問型。新潟市の例。' },
    { id: 'c24', text: '母乳・ミルクの併用を焦らない', category: 'body', note: '母乳が十分でない場合はミルクを併用。無理のない範囲で。' },
    { id: 'c25', text: 'パートナーの産後パパ育休を取得する', category: 'partner', note: '出産後8週間以内に4週間まで。休業開始予定日の2週間前までに申し出を。' },
    { id: 'c26', text: '自宅の受動喫煙防止を確認する', category: 'life', note: '妊婦・乳幼児のそばでは絶対に禁煙' },
  ],
  shopping: [
    { id: 's1', name: '産後ナイトブラ', priority: 'must', timing: '出産前後', priceYenMin: 2000, priceYenMax: 6000, note: '授乳しやすいデザイン' },
    { id: 's2', name: '産褥パッド', priority: 'must', timing: '出産前後', priceYenMin: 1500, priceYenMax: 5000, note: '入院中から産後2〜3週間' },
    { id: 's3', name: 'ベビー用おむつ（新生児）', priority: 'must', timing: '出産前後', priceYenMin: 2000, priceYenMax: 6000, note: '1日10枚以上を想定' },
    { id: 's4', name: 'ミルクセット（粉ミルク・哺乳瓶）', priority: 'should', timing: '出産前後', priceYenMin: 3000, priceYenMax: 10000, note: '母乳併用の場合も準備' },
    { id: 's5', name: '授乳ケープ', priority: 'should', timing: '出産前後', priceYenMin: 2000, priceYenMax: 5000, note: '外出時や来客時に便利' },
    { id: 's6', name: 'ベビー用体温計', priority: 'should', timing: '出産前後', priceYenMin: 2000, priceYenMax: 5000, note: '非接触式または耳式' },
    { id: 's7', name: 'おしり拭き（大量）', priority: 'must', timing: '出産前後', priceYenMin: 1000, priceYenMax: 3000, note: '新生児用の低刺激タイプ' },
    { id: 's8', name: 'ベビー沐浴セット', priority: 'should', timing: '出産前後', priceYenMin: 2000, priceYenMax: 6000, note: '湯温計・タオル・洗剤など' },
    { id: 's9', name: '授乳枕', priority: 'nice', timing: '出産前後', priceYenMin: 2000, priceYenMax: 6000, note: '腰の負担軽減に' },
    { id: 's10', name: 'ママ用ヘアバンド・スリッパ', priority: 'nice', timing: '出産前後', priceYenMin: 1000, priceYenMax: 3000, note: '入院中の快適さ向上' },
    { id: 's11', name: '搾乳機（電動または手動）', priority: 'nice', timing: '出産前後', priceYenMin: 3000, priceYenMax: 20000, note: '母乳の量や生活に合わせて' },
    { id: 's12', name: 'ベビー用爪切り', priority: 'should', timing: '出産前後', priceYenMin: 500, priceYenMax: 2000, note: '新生児用の安全設計' },
    { id: 's13', name: 'おむつ用ゴミ箱', priority: 'nice', timing: '出産前後', priceYenMin: 2000, priceYenMax: 6000, note: '臭い対策に' },
    { id: 's14', name: '哺乳瓶消毒器', priority: 'nice', timing: '出産前後', priceYenMin: 2000, priceYenMax: 8000, note: '電子レンジ・薬液・煮沸などタイプを選ぶ' },
  ],
  warnings: [
    { id: 'w1', label: '大量の出血', level: 'urgent' },
    { id: 'w2', label: '激しい痛み', level: 'urgent' },
    { id: 'w3', label: '意識消失', level: 'urgent' },
    { id: 'w4', label: '呼吸困難', level: 'urgent' },
    { id: 'w5', label: '発熱', level: 'watch' },
    { id: 'w6', label: '傷の痛み', level: 'watch' },
    { id: 'w7', label: '乳腫れ', level: 'watch' },
    { id: 'w8', label: '赤ちゃんの反応が弱い', level: 'watch' },
    { id: 'w9', label: '授乳ができない', level: 'watch' },
    { id: 'w10', label: '気分の落ち込みが強い', level: 'watch' },
    { id: 'w11', label: '新生児の黄疸が強い・長引く', level: 'watch' },
    { id: 'w12', label: 'おへその出血・化膿', level: 'watch' },
    { id: 'w13', label: '赤ちゃんの呼吸が速い・苦しそう', level: 'urgent' },
  ],
  partner: [
    { id: 'p1', text: '立ち会い・待機でできる役割を確認する' , detail: '立ち会い・待機中にできること（水分、声かけ、連絡）を産院ルールに沿って確認。'},
    { id: 'p2', text: '退院後の家事を引き継ぐ準備をする' , detail: '退院後48時間の家事・買い物をパパ主導に。食事は作り置きや宅配も活用。'},
    { id: 'p3', text: 'ママの休息を優先する声かけをする' , detail: '睡眠優先の声かけと、来客・連絡の調整を引き受ける。'},
    { id: 'p4', text: '出生届や手続きを一緒に進める' , detail: '出生届（14日以内）や一時金の流れを病院の案内と照合し、必要書類を袋にまとめる。'},
    { id: 'p5', text: '夜間のおむつ替え・授乳をサポートする' , detail: '夜間のおむつ・寝かしつけを交代制に。授乳中はママの水分補給を手伝う。'},
    { id: 'p6', text: '赤ちゃんの様子を観察し報告する' , detail: '赤ちゃんの哺乳・排泄・黄疸の様子をメモし、不安なら一緒に相談。'},
    { id: 'p7', text: '退院時の交通手段を確認する' , detail: '退院の迎え時間・チャイルドシート・経路を前日に確定。'},
    { id: 'p8', text: '産後パパ育休の取得を会社へ申し出る' , detail: 'パパ育休の取得日を会社と最終確認し、家事シフトに反映する。'},
  ],
  tips: [
    {
      id: 't1',
      title: '出産計画は「希望」として持つ',
      body: '陣痛や出産は予測できません。計画通りいかなくても、ママと赤ちゃんの安全が最優先。柔軟な気持ちで臨みましょう。',
    },
    {
      id: 't2',
      title: '産後すぐは水分と休息',
      body: '授乳や回復で水分が必要。赤ちゃんが寝たら一緒に寝る。家事は後回しでOKです。',
    },
    {
      id: 't3',
      title: '授乳は焦らなくていい',
      body: '母乳がすぐ出なくてもミルクで補えば大丈夫。助産師や母乳外来に相談しながら続けましょう。',
    },
    {
      id: 't4',
      title: 'おむつ替えは「安全・落ち着いて」',
      body: '最初はぎこちなくても、赤ちゃんに声をかけながら行うと慣れます。必ず手を洗い、目を離さない。',
    },
    {
      id: 't5',
      title: '母乳・ミルクは併用OK',
      body: '母乳育児にこだわりすぎず、ママのストレスや赤ちゃんの栄養を第一に。ミルクを併用しても大丈夫です。',
    },
    {
      id: 't6',
      title: '新生児の急な病気は#8000',
      body: '休日・夜間に受診すべきか迷ったら、新潟市などの「こども医療電話相談#8000」で看護師等に相談できます。',
    },
    {
      id: 't7',
      title: '受動喫煙を防ぐ',
      body: '加熱式たばこも含め、妊婦・乳幼児のそばでは吸わないルールを。換気扇下でも副流煙は防げません。',
    },
    {
      id: 't8',
      title: '市販薬は医師に相談',
      body: '持病の薬を勝手に止めたり、市販薬を飲んだりしない。産婦人科・主治医・薬剤師に必ず相談しましょう。',
    },
  ],
  adminGuide: [
    { id: 'a1', title: '出生届の提出', body: '出産後14日以内に父または母の本籍地または住所地の市区町村へ。産院から交付される書類を添えて提出しましょう。', when: '出産後14日以内' },
    { id: 'a2', title: '出産育児一時金の請求', body: '健康保険加入者なら産院経由で直接支払いに充当、または事後請求が可能。手続きは産院が案内してくれます。', when: '出産時または直後' },
    { id: 'a3', title: '乳児医療証の交付', body: '出生届提出後、自治体から乳児医療費助成の手続き案内が届きます。小児科受診時に提示すると助成を受けられます。', when: '出生届提出後' },
    { id: 'a4', title: '児童手当の申請', body: '中学校3年生までの子どもが対象。0歳児は満3歳まで月額15,000円（所得制限あり）。出生した月の月末までに申請を。', when: '出生後すぐ' },
    { id: 'a5', title: '父親の出生時育児休業', body: '出産後8週間以内に取得可能。雇用保険から給付金が支給されます。会社へ事前に申請を。', when: '出産後8週間以内' },
    { id: 'a6', title: '母子健康手帳の交付確認', body: '産院または自治体で母子健康手帳を受け取り、新生児の健診スケジュールを確認しましょう。', when: '出産直後' },
    { id: 'a7', title: '新生児聴覚検査・先天性代謝異常検査', body: '聴覚検査は生後すぐに、代謝異常検査は生後4〜6日頃に採血。早期発見のために受けましょう。', when: '生後すぐ〜1週間' },
    { id: 'a8', title: '産後ケア事業の利用', body: '新潟市では宿泊型・デイ型・訪問型の産後ケアがあります。事前に申請が必要な場合も。', when: '出産直後〜産後6か月' },
    { id: 'a9', title: 'こども医療費助成の申請', body: '子どもの医療費の自己負担額を助成。自治体により対象年齢や助成内容が異なります。健康保険加入後に手続きを。', when: '出生後速やかに' },
    { id: 'a10', title: '新潟県こむすび定期の申請', body: '新潟県内で生まれた1歳未満の子どもが対象。1歳の誕生日の前日までに県の電子申請システムから申請します。', when: '1歳の誕生日前日まで' },
    { id: 'a11', title: '子ども医療電話相談（#8000）', body: '新潟市などで、休日・夜間に子どもの病気やけがで受診すべきか迷った時に看護師等へ相談できます。', when: '緊急時' },
  ],
  careScenes: [
    {
      id: 'cs1',
      title: 'おむつ替え',
      items: [
        'おむつ・おしり拭き・防水シートを準備',
        '必ず手を洗い、目を離さない',
        '女の子は前から後ろへ拭く',
        'おむつかぶれが気になったら保湿剤を薄く',
        '使用済みおむつは衛生的に処理',
      ],
    },
    {
      id: 'cs2',
      title: '授乳・ミルク',
      items: [
        '母乳の場合は3時間おき程度、的需求でOK',
        'ミルクは正しい濃さ・温度で作る',
        '哺乳瓶は使用前後に消毒',
        'げっぷを出すのを忘れずに',
        '授乳後は30分程度、横向きに寝かせる',
      ],
    },
    {
      id: 'cs3',
      title: '沐浴',
      items: [
        '室温を温め、用意するものをそろえる',
        '湯温は38〜40度を目安',
        '首・わき・おむつまわりをやさしく洗う',
        '顔は別の湯でやさしくふく',
        '洗い終わったらすぐに水分を拭き、保湿',
      ],
    },
    {
      id: 'cs4',
      title: 'お出かけ',
      items: [
        'チャイルドシートの取り付けを再確認',
        'おむつ・おしり拭き・着替えを多めに',
        '外出時間は短時間から始める',
        '授乳スペースのある施設を選ぶ',
        '人混みを避け、ママも無理しない',
      ],
    },
  ],
  exercises: [
    {
      id: 'ex1',
      title: 'やさしい呼吸とストレッチ（妊婦ヨガ）',
      durationMin: 22,
      url: 'https://www.youtube.com/watch?v=-3bvlFKeLRE',
      channel: 'アドリエンのヨガ',
      note: '呼吸法とやさしい動きのみ行ってください。破水・出血・腹痛がある場合は絶対に中止し、医師の許可が前提です。',
      level: 'gentle',
    },
  ],
};
